<smt-custom-list [viewerConfigId]="viewerConfigId"></smt-custom-list>